import { forwardRef, useImperativeHandle, useRef } from 'react';

import { FiSearch, FiX } from 'react-icons/fi';

import { Formik, FormikProps } from 'formik';

import ComponentButtonBase from 'components/button/Base';
import ComponentInputSimple from 'components/input/Simple';

import colors from 'styles/colors';
import Forms from 'styles/forms';

export interface IProductFilterData {
  description: string;
  ean: string;
  manufacturer: string;
  sku: string;
}

interface IProductFilterProps {
  isLoading: boolean;
  onClear: () => void;
  onSubmit: (data: IProductFilterData) => void;
}

const ProductFilter: React.ForwardRefRenderFunction<
  FormikProps<IProductFilterData>,
  IProductFilterProps
> = ({ isLoading, onClear, onSubmit }, ref) => {
  const filterFormikRef = useRef<FormikProps<IProductFilterData>>(
    {} as FormikProps<IProductFilterData>,
  );

  useImperativeHandle(ref, () => ({
    ...filterFormikRef.current,
  }));

  return (
    <Formik
      initialValues={{
        description: '',
        ean: '',
        sku: '',
        manufacturer: '',
      }}
      innerRef={filterFormikRef}
      onSubmit={onSubmit}
    >
      {({ errors, handleChange, values }) => (
        <Forms.Content>
          <Forms.Grid
            gridTemplateColumns="6rem 8rem 17rem 13rem repeat(2, 2rem)"
            marginBottom="0"
          >
            <ComponentInputSimple
              errorMessage={errors.sku}
              hasError={!!errors.sku}
              height="2rem"
              label="SKU"
              onChange={handleChange('sku')}
              value={values.sku}
            />
            <ComponentInputSimple
              errorMessage={errors.ean}
              hasError={!!errors.ean}
              height="2rem"
              label="Código de barras"
              onChange={handleChange('ean')}
              value={values.ean}
            />
            <ComponentInputSimple
              errorMessage={errors.description}
              hasError={!!errors.description}
              height="2rem"
              label="Nome"
              onChange={handleChange('description')}
              value={values.description}
            />
            <ComponentInputSimple
              errorMessage={errors.manufacturer}
              hasError={!!errors.manufacturer}
              height="2rem"
              label="Fabricante"
              onChange={handleChange('manufacturer')}
              value={values.manufacturer}
            />
            <ComponentButtonBase
              backgroundColor={colors.gray300}
              disabled={isLoading}
              height="2rem"
              isLoading={isLoading}
              onClick={onClear}
              title="Limpar pesquisa"
            >
              <FiX size={18} />
            </ComponentButtonBase>
            <ComponentButtonBase
              disabled={isLoading}
              height="2rem"
              title="Pesquisar"
              type="submit"
            >
              <FiSearch size={18} />
            </ComponentButtonBase>
          </Forms.Grid>
        </Forms.Content>
      )}
    </Formik>
  );
};

export default forwardRef(ProductFilter);
